import type { Routes } from '@angular/router';
import { authGuard, guestGuard } from '@soft2code/nexpo-lib/core';

/**
 * O console da plataforma — para quem opera o NEXPO, não para o cliente.
 *
 * ⚠️ Falta o papel `OWNER` na API (`ADMIN|COORDINATOR|…` não o inclui). Quando
 * ele existir, a moldura ganha `roleGuard('OWNER')`; até lá nenhum papel local
 * é inventado — um `OWNER` que só existe no front daria a impressão de
 * controle onde não há nenhum.
 */
export const routes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: 'support' },
	{
		path: 'sign-in',
		canActivate: [guestGuard],
		loadComponent: () => import('./features/account/sign-in-page/sign-in-page').then((m) => m.SignInPage),
	},
	{
		path: '',
		canActivate: [authGuard],
		loadComponent: () => import('./layout/owner-shell/owner-shell').then((m) => m.OwnerShell),
		children: [
			{
				path: 'support',
				loadComponent: () => import('./features/support/support-page/support-page').then((m) => m.SupportPage),
			},
			{
				path: 'proposals',
				loadComponent: () => import('./features/proposals/proposals-page/proposals-page').then((m) => m.ProposalsPage),
			},
			{ path: 'fairs', loadChildren: () => import('./features/fairs/fairs.routes').then((m) => m.FAIRS_ROUTES) },
			{
				path: 'notices',
				loadComponent: () => import('./features/notices/notices-page/notices-page').then((m) => m.NoticesPage),
			},
		],
	},
	{ path: '**', redirectTo: 'support' },
];
